export class AppColors {
  static LIGHT_BORDER = '#D5D5D5';
  static LIGHT_GREEN_TEXT = '#009944';
  static WHITE_TEXT = '#F1F1F1';
  static DARK_GREEN_TEXT = '#004422';
  static LIGHT_GRAY_TEXT='#3B3B3B'
  static LIGHT_BACKGROUND = '#FAFAFA';
}
